// @flow
import * as Sentry from '@sentry/react';

export const initializeSentryClient = (dsn?: string) => {
  // Initialize Sentry client to capture all unhandled exceptions
  if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
      dsn:
        dsn || 'https://051ef4a8994d4b57ae3ca07bd9502949@errors.stripe.com/436',
      ignoreErrors: [
        // https://stackoverflow.com/questions/55738408/javascript-typeerror-cancelled-error-when-calling-fetch-on-ios
        'TypeError: Cancelled',
        'TypeError: cancelled',
      ],
    });
  }
};
